import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["escape", "portal", "print", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Modal } from '../../internal/components/Modal';
import { ModalFullscreenView } from './ModalFullscreenView';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для рендера полноэкранного модального окна
 *
 * @export
 * @class ModalFullscreen
 * @extends {React.Component<IModalFullscreenProps>}
 */
export function ModalFullscreen(_ref) {
  var _ref$escape = _ref.escape,
    escape = _ref$escape === void 0 ? true : _ref$escape,
    _ref$portal = _ref.portal,
    portal = _ref$portal === void 0 ? true : _ref$portal,
    _ref$print = _ref.print,
    print = _ref$print === void 0 ? true : _ref$print,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'white' : _ref$theme,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, _objectSpread(_objectSpread({
    escape: escape,
    portal: portal
  }, props), {}, {
    children: /*#__PURE__*/_jsx(ModalFullscreenView, _objectSpread(_objectSpread({
      print: print,
      theme: theme
    }, props), {}, {
      children: props.children
    }))
  }));
}